enum GeneralLedgerAccountType {
    Asset = "ASSET",
    Liability = "LIABILITY",
    Income = "INCOME",
    Expense = "EXPENSE",
    Equity = "EQUITY",
}
export default GeneralLedgerAccountType